// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1426":"b447a86854dc0131","1900":"a5c0878d617afaa0"}[chunkId] + ".css";
};